import { render, staticRenderFns } from "./PatientInsuranceForm.vue?vue&type=template&id=c3785648&scoped=true&"
import script from "./PatientInsuranceForm.vue?vue&type=script&lang=js&"
export * from "./PatientInsuranceForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientInsuranceForm.vue?vue&type=style&index=0&id=c3785648&prod&scoped=true&lang=css&"
import style1 from "./PatientInsuranceForm.vue?vue&type=style&index=1&id=c3785648&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3785648",
  null
  
)

export default component.exports